import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as SettingTicketAPI from "@/api/setting-ticket";
import { isSuccess } from "@/api/response";
import { RegisterRequest } from "@/api/setting-ticket/request";
import { CommonResponse } from "@/api/response";

const MODULE_NAME = "setting-ticket/regist";

/**
 * スタンプカード設定情報取得APIのレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Modify extends VuexModule {
  // state
  commonResponse: CommonResponse = {} as CommonResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.commonResponse);
  }

  get getMessage() {
    return this.commonResponse.message;
  }

  @MutationAction
  async register(registerRequest: RegisterRequest) {
    const commonResponse = await SettingTicketAPI.register(registerRequest);
    return {
      commonResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      commonResponse: {} as CommonResponse
    };
  }
}

export default getModule(Modify);
